import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody, FormControl} from 'react-bootstrap';
import iconsSvg from '../../assets/img/svgLib/iconsSvg';
import classNames from 'classnames';
import './ModalWindow.scss';

class ModalWindow extends Component {
    static propTypes = {
      classPrefix: PropTypes.string,
      title: PropTypes.string,
      buttonTxt: PropTypes.string,
      text: PropTypes.string,
      handler: PropTypes.func,
      show: PropTypes.bool,
      type: PropTypes.string,
    }
    constructor(props) {
      super(props);

      this.state = {
        emailRestore: '',
      };
    }

    componentWillMount() {
      document.addEventListener('click', this.checkOutsideClick, false);
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.checkOutsideClick, false);
    }

    sendToEmail = () => {
      const {emailRestore} = this.state;

      emailRestore && console.log('тут типа проверяем мыло на валидность');
    };

    handleButtonClick = () => {
      const {handler} = this.props;
      this.sendToEmail();
      handler(false);
    };


    handleRestoreEmail = (e) => {
      this.setState({
        emailRestore: e.target.value,
      });
    };

    checkOutsideClick = (e) => {
      const {handler} = this.props;

      if (this.node) {
        if (this.node.contains(e.target)) {
          return;
        }
        handler(false);
      }
    };

    get restorePasswordWindow() {
      const {show, buttonTxt, handler, text, title, classPrefix} = this.props;
      const {emailRestore} = this.state;
      return (
        <Modal show={show}>
          <div ref={(node) => this.node = node}
            className={`modalWindow${classPrefix}`}>
            <ModalHeader>
              <div onClick={() => handler(!show)}>
                {iconsSvg.back}
              </div>
              <div className={'modalHeader'}>
                <span>{title}</span>
              </div>
            </ModalHeader>
            <ModalBody>
              <div className={'modalBodyInput'}>
                <FormControl
                  type={'text'}
                  value={emailRestore}
                  placeholder={'Ваш e-mail'}
                  onChange={this.handleRestoreEmail} />
              </div>
              <div className={'modalBodyText'}>
                {text}
              </div>
              <div
                className={classNames('buttonNext', {
                  'disabled': !emailRestore,
                })}
                onClick={emailRestore &&
                                this.handleButtonClick}>
                {buttonTxt}
              </div>
            </ModalBody>
          </div>
        </Modal>);
    }


    render() {
      const {restorePasswordWindow} = this;
      const {type} = this.props;
      return type === 'restore' ? restorePasswordWindow : null;
    }
}

export default ModalWindow;



// WEBPACK FOOTER //
// ./src/shared/ModalWindow/ModalWindow.js